import * as SC from '../styled';
export const DragHandle = () => {
  return (
    <SC.DragRoot>
      <SC.DragDots />
      <SC.DragDots />
      <SC.DragDots />
    </SC.DragRoot>
  );
};
